<template>
  <slot 
      :needPagination="needPagination"
      :pagination="pagination"
      :nextPage="nextPage"
      :prevPage="prevPage"
      :gotoPage="gotoPage"
  />
</template>

<script setup>
    import { computed, defineProps } from 'vue'

    const props = defineProps(['componentClass', 'currentPage', 'pagination', 'gotoPage'])

    const needPagination = computed(() => props.pagination.pages > 1)

    const pagination = computed(() => {
        const numPages = props.pagination.pages
        const currentPage = props.pagination.page || 0
        const numForward = 2
        
        const pages = []
        const startPage = Math.max(0, currentPage - numForward)
        const endPage = Math.min(currentPage + numForward, numPages)

        if (startPage > 0) {
            pages.push(0)

            if (startPage != 1) {
                pages.push(null)
            }
        }

        for (let p = startPage; p < endPage; ++p) {
            pages.push(p)
        }

        if (endPage != numPages) {
            if (endPage != numPages - 1) {
                pages.push(null)
            }
            pages.push(numPages - 1)
        }

        return {
            prev: currentPage > 0,
            next: currentPage < numPages - 1,
            limit: props.pagination.limit,
            count: props.pagination.count,
            current: props.pagination.page,
            page: props.pagination.page,
            pages
        }
    })

    function prevPage() { 
        gotoPage(props.currentPage - 1)
    }
    function nextPage() { 
        gotoPage(props.currentPage + 1)
    }
    function gotoPage(page) { 
        if (page < 0) { page = 0 } // can negatively index in the future if we need to
        if (page >= props.pagination.pages) {
            page = props.pagination.pages - 1
        }
        if (page != props.currentPage) {
            props.gotoPage(page)
        }
    }
</script>
